import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "font-grey" }
const _hoisted_3 = {
  key: 2,
  class: "text-center"
}
const _hoisted_4 = { key: 3 }

import {computed, reactive, shallowRef, watch} from 'vue';
import {useSettingsStore} from '@/api/store/settings';
import {useRouter} from 'vue-router';
import {healthGoalsService} from "@/api/services/healthGoals";
import SearchFilter from "@/components/custom/SearchFilter.vue";
import ButtonBase from "@/components/custom/ButtonBase.vue";
import ButtonFixed from "@/components/custom/ButtonFixed.vue";
import {filterValues, sortValues} from "@/views/ClientComponents/HealthGoals/Helpers";
import ButtonFilterSelect from "@/components/custom/ButtonFilterSelect/ButtonFilterSelect.vue";
import debounce from 'lodash/debounce';
import HealthGoalCard from "@/views/ClientComponents/HealthGoals/Components/HealthGoalCard.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HealthGoals',
  setup(__props) {

const settingsStore = useSettingsStore();

const router = useRouter();

// Data
const state = reactive({
  items: [] as any[],
  pagination: {
    meta: {},
    links: []
  },
  search: '' as string,
  filterSelected: 'filter' as string,
});

const sortTabSelectedValue = shallowRef({
  name: 'Sort',
  label: 'Sort'
})
const filterTabSelectedValue = shallowRef({
  name: 'Filter',
  label: 'Filter'
})
const page = shallowRef(1)

const tabStatusSelected = shallowRef('active');

// Computed
const isFilterTabSelected = computed(() => {
  return state.filterSelected === 'filter'
});

const isSortTabSelected = computed(() => {
  return state.filterSelected === 'sort'
});

const filterQueryString = computed(() => {
  let filter = {
    sorting: '',
    search: state.search,
    tab: tabStatusSelected.value,
    page: page.value
  };

  let sortOrder = sortTabSelectedValue.value.name === 'Sort' ? 'desc' : sortTabSelectedValue.value.name;
  let filterValue = filterTabSelectedValue.value.name === 'Filter' ? 'name' : filterTabSelectedValue.value.name;

  if (filterTabSelectedValue.value.name === 'Filter' && sortTabSelectedValue.value.name === 'Sort') {
    filter.sorting = 'id,desc';
  } else {
    filter.sorting = `${filterValue},${sortOrder}`;
  }

  return filter;
});

// Methods
const getHealthGoals = () => {
  
  healthGoalsService.index(filterQueryString.value).then((response) => {
    state.items.push(...response.data)
    state.pagination.meta = response.meta;
    state.pagination.links = response.links;
    
  });
}

const resetState = () => {
  page.value = 1;
  state.items = [];
}

const seeMore = () => {
  if (state.pagination.links.next) {
    page.value++;
    getHealthGoals();
  }
}

// Debounced to fetch getHealthGoals
const debouncedHealthGoal = debounce(getHealthGoals, 300);

const onActiveTab = () => {
  tabStatusSelected.value = 'active';
  resetState();
  getHealthGoals();
}
const onArchivedTab = () => {
  tabStatusSelected.value = 'archived';
  resetState();
  getHealthGoals();
}

watch(() => [filterTabSelectedValue.value, sortTabSelectedValue.value, state.search], () => {
  resetState();
  debouncedHealthGoal();
});

getHealthGoals()

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "px-0 pt-0 mb-12 position-relative",
    style: {"background-color":"#F0F0F0","min-height":"100vh"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "mt-0 mb-2 py-5 text-center",
        "no-gutters": "",
        style: {"background-color":"#FFF"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(SearchFilter, {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => state.search = val)
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "d-flex px-3",
            cols: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "mt-1 position-relative left-filter-text",
                onClick: _cache[2] || (_cache[2] = ()=>state.filterSelected = 'sort')
              }, {
                default: _withCtx(() => [
                  _createVNode(ButtonFilterSelect, {
                    modelValue: sortTabSelectedValue.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sortTabSelectedValue).value = $event)),
                    "is-tab-selected": isSortTabSelected.value,
                    items: _unref(sortValues),
                    multiple: false,
                    text: sortTabSelectedValue.value,
                    icon: "sort-icon",
                    "single-line": ""
                  }, null, 8, ["modelValue", "is-tab-selected", "items", "text"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                class: "mt-1 position-relative left-filter-text",
                onClick: _cache[4] || (_cache[4] = ()=> state.filterSelected = 'filter')
              }, {
                default: _withCtx(() => [
                  _createVNode(ButtonFilterSelect, {
                    modelValue: filterTabSelectedValue.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterTabSelectedValue).value = $event)),
                    "is-tab-selected": isFilterTabSelected.value,
                    items: _unref(filterValues),
                    multiple: false,
                    text: filterTabSelectedValue.value,
                    "single-line": ""
                  }, null, 8, ["modelValue", "is-tab-selected", "items", "text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        class: "text-center py-0",
        "no-gutters": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            class: "d-flex px-4",
            cols: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(ButtonBase, {
                    "custom-class": ['transparent text-black', {'secondary-button text-white': tabStatusSelected.value === 'active'}],
                    text: "Active",
                    width: "100%",
                    onClick: onActiveTab
                  }, null, 8, ["custom-class"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(ButtonBase, {
                    "custom-class": ['transparent text-black', {'secondary-button text-white': tabStatusSelected.value === 'archived'}],
                    text: "Archived",
                    width: "100%",
                    onClick: onArchivedTab
                  }, null, 8, ["custom-class"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (!_unref(settingsStore).loading)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.items, (healthGoal) => {
              return (_openBlock(), _createBlock(HealthGoalCard, {
                key: healthGoal.id,
                "health-goal": healthGoal,
                class: "font-size-12-400"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(healthGoal.timeframe_value) + " " + _toDisplayString(healthGoal.timeframe_unit), 1)
                ]),
                _: 2
              }, 1032, ["health-goal"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (state.items.length == 0)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 1,
            class: "mt-2 mx-2 mb-2 pa-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                class: "my-0",
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { class: "py-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "pt-3 px-3" }, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createElementVNode("p", { class: "p-text mt-1" }, "No health goals available.", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (state.pagination.links.next)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_v_btn, {
              ripple: false,
              class: "load-more text-capitalize font-size-12-600",
              variant: "plain",
              onClick: seeMore
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" Load More ", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (tabStatusSelected.value === 'active')
        ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
            _createVNode(ButtonFixed, {
              "color-icon": "primaryButtonColor",
              "custom-class": "text-white primary-button",
              "custom-icon-class": "add-new-circle-icon",
              icon: "add-plus-circle",
              text: "Add New",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push({ name: 'create-health-goals' })))
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})